import React from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {
  activateHolidayMode,
  deactivateHolidayMode
} from '../redux/actions/user';

import AdornedButton from './AdornedButton';
import RTVDialog from './dialogs/RTVDialog';
import RTVSwitch from './RTVSwitch';
import {
  ACTIVATE_HOLIDAY_MODE_REQUESTED,
  ACTIVATE_HOLIDAY_MODE_SUCCESSFULL,
  ACTIVATE_HOLIDAY_MODE_ERRORED,
  DEACTIVATE_HOLIDAY_MODE_REQUESTED,
  DEACTIVATE_HOLIDAY_MODE_SUCCESSFULL,
  DEACTIVATE_HOLIDAY_MODE_ERRORED
} from '../redux/actions/types';
import { useTranslation } from 'react-i18next';

const RTVHolidayMode = ({
  status,
  user,
  activateHolidayMode,
  deactivateHolidayMode,
  hasReservedProducts,
  switchProps = {}
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [holidayMode, setHolidayMode] = React.useState(
    user.roles.includes('ROLE_VACATION')
  );
  const [activateConfirmation, setActivateConfirmation] = React.useState(false);
  const [deactivateConfirmation, setDeactivateConfirmation] = React.useState(
    false
  );

  React.useEffect(() => {
    if (status === ACTIVATE_HOLIDAY_MODE_REQUESTED) {
      setLoading(true);
    }
    if (status === ACTIVATE_HOLIDAY_MODE_SUCCESSFULL) {
      setLoading(false);
      setHolidayMode(true);
      setActivateConfirmation(false);
    }
    if (status === ACTIVATE_HOLIDAY_MODE_ERRORED) {
      setLoading(false);
      setHolidayMode(false);
    }

    if (status === DEACTIVATE_HOLIDAY_MODE_REQUESTED) {
      setLoading(true);
    }
    if (status === DEACTIVATE_HOLIDAY_MODE_SUCCESSFULL) {
      setLoading(false);
      setHolidayMode(false);
      setDeactivateConfirmation(false);
    }
    if (status === DEACTIVATE_HOLIDAY_MODE_ERRORED) {
      setLoading(false);
      setHolidayMode(true);
    }
  }, [status]);

  const onChange = () => {
    if (loading) {
      return;
    }

    if (holidayMode) {
      setDeactivateConfirmation(true);
    } else {
      setActivateConfirmation(true);
    }
  };

  let holidayAlertMessage = t('pendingSales', { ns: 'dresser' });
  if (hasReservedProducts) {
    holidayAlertMessage = t('pendingProducts', { ns: 'dresser' });
  }

  return (
    <>
      <RTVDialog
        open={activateConfirmation}
        onClose={() => setActivateConfirmation(false)}
        title="Estás pausando todos tus productos a la venta"
        content={
          <Typography style={{ textAlign: 'center' }}>
            {holidayAlertMessage}
          </Typography>
        }
        actionSection={
          <>
            <Button
              variant="contained"
              color="secondary"
              disabled={loading}
              onClick={() => setActivateConfirmation(false)}
            >
              Cancelar
            </Button>
            <AdornedButton
              variant="contained"
              color="primary"
              loading={loading}
              disabled={loading}
              onClick={() => activateHolidayMode()}
            >
              SÍ! ME VOY DE VACACIONES
            </AdornedButton>
          </>
        }
      />
      <RTVDialog
        open={deactivateConfirmation}
        onClose={() => setDeactivateConfirmation(false)}
        title="Estás activando todos tus productos a la venta"
        content={
          <Typography style={{ textAlign: 'center' }}>
            Tus productos volverán a estar disponibles
          </Typography>
        }
        actionSection={
          <>
            <Button
              variant="contained"
              color="secondary"
              disabled={loading}
              onClick={() => setDeactivateConfirmation(false)}
            >
              Cancelar
            </Button>
            <AdornedButton
              variant="contained"
              color="primary"
              loading={loading}
              disabled={loading}
              onClick={() => deactivateHolidayMode()}
            >
              OK, ACTIVAR
            </AdornedButton>
          </>
        }
      />
      <RTVSwitch
        disabled={loading}
        checked={holidayMode}
        onClick={onChange}
        {...switchProps}
      />
    </>
  );
};

const mapStateToProps = state => ({
  status: state.user.status,
  user: state.user.user
});

const mapDispatchToProps = dispatch => ({
  activateHolidayMode: () => dispatch(activateHolidayMode()),
  deactivateHolidayMode: () => dispatch(deactivateHolidayMode())
});

export default connect(mapStateToProps, mapDispatchToProps)(RTVHolidayMode);
